import { render, staticRenderFns } from "./xmgdView.vue?vue&type=template&id=81e05d04&scoped=true"
import script from "./xmgdView.vue?vue&type=script&lang=js"
export * from "./xmgdView.vue?vue&type=script&lang=js"
import style0 from "./xmgdView.vue?vue&type=style&index=0&id=81e05d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e05d04",
  null
  
)

export default component.exports